// API configuration
const API_CONFIG = {
  // Base URL for all API requests
  // baseURL: 'http://localhost:3000',
  // Production API (uncomment when deploying)
  baseURL: 'https://api.gymlov.com'
};

export default API_CONFIG;
